import { Coords } from "interfaces/Coords";
import { MapListItem, MapListItemProps } from "../MapListItem";

import * as S from "./styles";

type Props = {
  list: MapListItemProps[];
  onPinClick: (coords: Coords) => void;
};

function MapList({ list, onPinClick }: Props) {
  return (
    <S.Wrapper>
      <S.Header>
        <p>No mapa agora</p>
        <span>
          Apenas os dados dos filtros selecionados no mapa aparecerão abaixo
        </span>
      </S.Header>

      {list.map((listItem, key) => (
        <MapListItem
          key={key}
          name={listItem.name}
          coords={listItem.coords}
          type={listItem.type}
          onPinClick={onPinClick}
        />
      ))}
    </S.Wrapper>
  );
}

export { MapList };
